<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Avatar from 'next/avatar/Avatar.vue';
import CompanyDetailsDialog from 'dashboard/components-next/Companies/CompanyDetailsDialog.vue';

const props = defineProps({
  contactId: { type: Number, required: true },
  company: { type: Object, default: null },
});

const { t } = useI18n();

const dialogRef = ref(null);
const hasCompany = computed(() => !!props.company);

const openDialog = () => dialogRef.value?.open();
</script>

<template>
  <div>
    <button
      type="button"
      class="flex items-center w-full gap-3 p-2 -mx-2 text-left transition-colors rounded-lg hover:bg-n-slate-2 dark:hover:bg-n-solid-2"
      @click="openDialog"
    >
      <Avatar
        v-if="hasCompany"
        :name="company.name"
        :src="company.avatar_url"
        :size="32"
        rounded-full
        hide-offline-status
      />
      <span
        v-else
        class="i-lucide-building text-xl text-n-slate-10 flex-shrink-0"
      />
      <div class="flex flex-col min-w-0">
        <span
          v-if="hasCompany"
          class="text-sm font-medium truncate text-n-slate-12"
        >
          {{ company.name }}
        </span>
        <span v-else class="text-sm text-n-slate-11">
          {{ t('CONTACTS_LAYOUT.DETAILS.COMPANY.EMPTY') }}
        </span>
        <span
          v-if="hasCompany && company.domain"
          class="text-xs truncate text-n-slate-11"
        >
          {{ company.domain }}
        </span>
        <span v-else-if="!hasCompany" class="text-xs text-n-blue-11">
          {{ t('CONTACTS_LAYOUT.DETAILS.COMPANY.ADD_TITLE') }}
        </span>
      </div>
    </button>

    <CompanyDetailsDialog
      ref="dialogRef"
      :contact-id="contactId"
      :company="company"
    />
  </div>
</template>
